export class GdsgDevStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "activeBatchJobs",
            "baseName": "activeBatchJobs",
            "type": "GdsgActiveBatchJobs",
            "format": ""
        },
        {
            "name": "workerHeartbeats",
            "baseName": "workerHeartbeats",
            "type": "GdsgWorkerHeartbeats",
            "format": ""
        },
        {
            "name": "consolidationQueueLag",
            "baseName": "consolidationQueueLag",
            "type": "GdsgQueueLagStats",
            "format": ""
        },
        {
            "name": "replicationQueueLag",
            "baseName": "replicationQueueLag",
            "type": "GdsgQueueLagStats",
            "format": ""
        },
        {
            "name": "bigtable",
            "baseName": "bigtable",
            "type": "GdsgBigtableClusterStats",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgDevStats.attributeTypeMap;
    }
    constructor() {
    }
}
